import { Component, input, output } from '@angular/core';

@Component({
  selector: 'ziro-service-tile-edit-multi',
  templateUrl: './service-tile-edit-multi.component.html',
  styleUrls: ['./service-tile-edit-multi.component.scss'],
  standalone: false,
})
export class ZiroServiceTileEditMultiComponent {
  readonly isEnabled = input(true);
  readonly serviceName = input<string>();
  readonly description = input<string>();
  readonly icon = input<string>();
  readonly tooltip = input<string>();
  readonly showAddButton = input(false);
  readonly multiEditAddClicked = output();
  multiEditAddHover = false;
  isHoverTile = false;

  onMultiEditAddClicked(): void {
    this.multiEditAddClicked.emit();
  }
}
